import { displayNotification, getPrivateMode } from './ui'

/*
 * One socket for the app, reconnecting on close. Kept as a module singleton
 * rather than a hook so `rtSend` stays callable from player callbacks.
 */
let socket: WebSocket | null = null

export function connectWs() {
  // CONNECTING and OPEN both mean a socket is on its way or in place.
  // The old check compared against OPEN only, so a call while a socket was
  // still connecting -- connectWs is invoked from several mounts, not
  // just the reconnect timer -- spawned a duplicate and orphaned the
  // first socket.
  if (socket && socket.readyState !== WebSocket.CLOSED) return

  const ws = new WebSocket(
    `${import.meta.env.REACT_APP_IZIPLAY_URL_WS}/?Authorization=Bearer ${window.localStorage.token}`
  )
  socket = ws

  ws.onmessage = msg => {
    try {
      const parsed = JSON.parse(msg.data)
      if (parsed.action === 'notification') {
        displayNotification(parsed.data.text, parsed.data.type)
      }
    } catch {
      // A malformed frame is not worth tearing the socket down for.
    }
  }

  ws.onclose = () => {
    // Only the current socket may null the reference and schedule a
    // reconnect: a superseded socket closing later would otherwise
    // clobber whichever live socket took its place and arm a second
    // reconnect loop.
    if (socket !== ws) return
    socket = null
    setTimeout(connectWs, 2000)
  }
}

export function rtSend(event: string, data: unknown) {
  if (!socket || socket.readyState !== WebSocket.OPEN) return false
  if (getPrivateMode()) return false

  socket.send(JSON.stringify({ event, data }))
  return true
}
